import React, { useCallback, useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import type { SAMAnnotationMetadata } from '../../../../../common/types/types';
import { getRandomId } from '../../../../../common/utils/utils';
import { useStageAtoms } from '../../../../labelling-v2/components/stage-scope/hooks';
import { ANNOTATION_TYPE, SAM_ANNOTATION_ACTIONS, SAM_CLICK } from '../../../constants';
import { useSamForReview } from '../../../providers/hooks/use-sam-for-review';
import useStage from '../../../providers/hooks/use-stage';
import { type StagePointerEventT } from '../../../providers/stage-provider';
import type { PolygonDataT } from '../../../types';
import { isLabelingMode } from '../../toolbar/utils';
import Polygon from '../polygon/polygon';
const SegmentationClick = ({
  isPolygon
}: {
  isPolygon?: boolean;
}) => {
  const {
    stage
  } = useStage();
  const {
    brushToolSettingsAtom,
    selectedAnnotationLabelAtom,
    currentFrameAtom,
    editorModeAtom,
    currentFrameAnnotationUnderUserReviewAtom
  } = useStageAtoms();
  const editorMode = useAtomValue(editorModeAtom);
  const currentFrame = useAtomValue(currentFrameAtom);
  const annotationUnderUserReview = useAtomValue(currentFrameAnnotationUnderUserReviewAtom);
  const {
    inclusionExclusion
  } = useAtomValue(brushToolSettingsAtom);
  const annotationLabel = useAtomValue(selectedAnnotationLabelAtom);
  const {
    addSamAnnotationForReview
  } = useSamForReview();
  const currentSegmentationId = useRef(getRandomId());
  const onPointerUp = useCallback((stageEvent: StagePointerEventT) => {
    if (!annotationLabel) return;
    const existingMetadata = annotationUnderUserReview[currentSegmentationId.current]?.annotationMetaData || [];
    const currentSAMMetadata = existingMetadata.filter((metadata): metadata is SAMAnnotationMetadata => 'data' in metadata && 'type' in metadata);
    const {
      detail: {
        mousePos
      }
    } = stageEvent;
    addSamAnnotationForReview(currentSegmentationId.current, {
      type: isPolygon ? SAM_ANNOTATION_ACTIONS.POLYGON : SAM_ANNOTATION_ACTIONS.POINT,
      annotationMetaData: [...currentSAMMetadata, {
        type: inclusionExclusion === SAM_CLICK.EXCLUDE ? SAM_CLICK.EXCLUDE : SAM_CLICK.INCLUDE,
        annotationLabel,
        data: {
          x: mousePos[0],
          y: mousePos[1],
          width: 0,
          height: 0
        }
      }],
      frameIndex: currentFrame
    });
  }, [annotationLabel, addSamAnnotationForReview, isPolygon, annotationUnderUserReview, inclusionExclusion, currentFrame]);
  useEffect(() => {
    if (!stage || !isLabelingMode(editorMode)) return;
    stage.addEventListener('pointerup', onPointerUp);
    return () => {
      stage.removeEventListener('pointerup', onPointerUp);
    };
  }, [stage, onPointerUp, editorMode]);
  const polygonAnnotationId = Object.keys(annotationUnderUserReview).find(
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  id => annotationUnderUserReview[id].type === SAM_ANNOTATION_ACTIONS.POLYGON);
  const hasPolygonPoints = isPolygon && polygonAnnotationId &&
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  annotationUnderUserReview[polygonAnnotationId].annotationData;
  return hasPolygonPoints && <Polygon isDrawing={false} annotation={{
    annotationType: ANNOTATION_TYPE.POLYGON,
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    data: (annotationUnderUserReview[polygonAnnotationId].annotationData?.[currentFrame] as PolygonDataT),
    annotationLabel:
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    annotationUnderUserReview[polygonAnnotationId].annotationMetaData[0].annotationLabel
  }} />;
};
export default SegmentationClick;